import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Accordion } from '../../components/Accordion'
import { ClientsBanner } from '../../components/ClientsBanner'
import { Icon } from '@iconify/react'

export default function MicroLoan() {
    return (
        <div>
            <Seo
                title="Guaranteed $100 Loan in Canada​ | Find The Best Offers | Good Good Finance"
                description="Compare guaranteed $100 loans in Canada on our site to find the ideal option for your financial needs. Access the best offers available."
                type="webapp"
                name="Good Good Finance"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Micro Loans</h1>

                    <p className="header-subtitle">
                        Good Good Finance is a 100% free online comparison tool designed to help you find fast micro
                        loans in Quebec. In just a few clicks, discover the best loans on the market to meet your needs.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Apply for a Loan
                    </Link>
                </div>
            </section>

            <section className="Situation-steps">
                <div className="content" data-aos="fade-up">
                    <h2 className="sect-title">Get a Micro Loan in 3 Quick and Easy Steps</h2>

                    <p className="sect-subtitle">
                        Unexpected bills, car trouble, broken phone… Whatever the situation, there’s a way to finance
                        your urgent needs! With our comparison tool, you can access a fast micro loan in Quebec or a
                        micro instant loan in just a few clicks:
                    </p>

                    <ol style={{ marginTop: 50 }}>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:note" width="40" />
                            </div>
                            <h3>Submit your request</h3>
                            <p>
                                Fill out our online form with your basic information and the amount you need. Within
                                seconds, you’ll get a list of lenders that match your criteria.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:home" width="40" />
                            </div>
                            <h3>Compare your options</h3>
                            <p>
                                Review the terms of each micro loan online, including repayment amount, duration,
                                interest rate, and payment schedule.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:paper-plane" width="40" />
                            </div>
                            <h3>Get approved quickly</h3>
                            <p>
                                Complete your application directly on the chosen lender’s website. Depending on business
                                hours, you could receive your funds the same day, and sometimes in less than an hour!
                            </p>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Micro Loans From $200 To $1,500</h2>

                    <p className="sect-subtitle">
                        Wondering what is the minimum amount for a micro loan? From small loans to larger amounts, we
                        understand that some situations call for urgent funding! Depending on your needs, you can access
                        different types of fast micro loans:
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>$200 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$300 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$500 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$700 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$1,000 loan</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>$1,500 loan</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">What Credit Score Do You Need for a Micro Loan?</h2>

                    <p className="sect-subtitle">
                        None in particular! While most traditional financing options involve a credit check, alternative
                        lenders use other approval methods. With <b>instant bank verification</b> (IBV loans), the
                        financial
                        institution can quickly assess your ability to repay the requested amount, without specific
                        documentation.
                    </p>
                    <p className="sect-subtitle">
                        With Good Good Finance, you can <b> find easy micro loans</b> without a credit check or even
                        micro loans for bad credit with no refusal through IBV.
                    </p>
                </div>
            </section>
            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">The Benefits of Our Micro Loans in Quebec</h2>

                    <p className="sect-subtitle">
                        To help you secure funds quickly, Good Good Finance conducts a full search of your financing
                        options in Quebec. Through our online platform, you can easily apply for personalized loans
                        designed to match your situation, without lengthy steps or complicated requirements.
                    </p>
                    <p className="sect-subtitle">
                        First, our offers include a loan without documents. Thanks to <b> instant bank verification </b>(IBV
                        loans), you avoid unnecessary paperwork and enjoy instant loans! In most cases, approval is
                        completed within just a few hours.
                    </p>
                    <p className="sect-subtitle">
                        We also provide <b> no credit check loans with no refusal.</b> Our verified partners make
                        borrowing accessible, no matter your credit score or financial situation. Plus, you can receive
                        your funds through an e-Transfer loan, ensuring nearly immediate access to your money.
                    </p>
                </div>
            </section>

            <section className="Eligible sect-bg-dark">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Financing Solutions Tailored to Your Needs</h2>
                        </div>
                        <p>
                            We know that in some cases, short term loans are the most practical solution! Our micro loans in Quebec can give you enough liquidity to handle an emergency expense, pay an urgent bill, or make an essential purchase. To qualify for fast micro loans in Canada, you simply need to:
                        </p>
                        <ul>
                            <li>Be at least 18 years old</li>
                            <li>Live in Quebec</li>
                            <li>Have no active payment opposition</li>
                            <li>Have a stable income of at least $1,400/month</li>
                            <li>Have minimal NSF (non-sufficient funds) fees</li>
                        </ul>
                        <p>
                            Ready to start your search? Explore your options on our site and find microcredit solutions that are effective, fast, and reliable!
                        </p>
                        <Link to="/new-lead" className="btn">
                            Apply for a loan
                        </Link>
                    </div>
                </div>
            </section>


            <ClientsBanner />

            <Footer />
        </div>
    )
}
